export default "__VITE_ASSET__CGJe_IyU__"